import { Skeleton } from '@shared/components/ui/shadcn/skeleton';
import { PrintersListSkeleton } from './PrintersListSkeleton';

export const PrintersSkeleton = () => {
  return (
    <div className="w-full pb-6" data-testid="printers-skeleton">
      <div className="space-y-2">
        <Skeleton className="h-8 w-32 rounded-full bg-hover-press" />
        <Skeleton className="h-4 w-80 max-w-full rounded-full bg-hover-press" />
      </div>

      <div className="mt-8 w-full">
        <PrintersListSkeleton />
      </div>
    </div>
  );
};
